module.exports = __webpack_public_path__ + "static/fonts/Mont-SemiBold.085d0f1.woff";